import * as Models from 'models';

export function getScreenPosition(surface: Models.ScreenMap, surfaces: Models.ScreensOrderedMap): number {
  return surfaces.keySeq().findIndex(id => id === surface.get('id')) + 1;
}
